import { Button, Modal } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ModalProp } from '../../types'

const ModalError = ({
  message,
  isModalOpen,
  closeModal,
  onAgain
}: ModalProp) => {
  const navigate = useNavigate()
  const handleCancel = () => {
    closeModal()
    navigate('/')
  }
  return (
    <Modal
      className='modal'
      title={
        <div className='text-[#00D4FF] text-xl font-bold'>ポイントチャージ</div>
      }
      centered
      open={isModalOpen}
      onCancel={handleCancel}
      footer={[
        <Button
          key='cancel'
          className='bg-[#D9D9D9] text-black font-semibold'
          onClick={handleCancel}
        >
          取消
        </Button>,
        <Button
          key='back'
          className='text-black font-semibold'
          type='primary'
          onClick={onAgain}
        >
          再決済
        </Button>
      ]}
    >
      <div className='text-lg'>決済に失敗しました</div>
      <div className='text-lg'>{message}</div>
    </Modal>
  )
}

export default ModalError
